module.exports = __webpack_public_path__ + "static/media/Retro-Sprint-2-Audio-2.ac297777.mp3";